import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layout
import Header from '../Header/Header';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

// Public Pages
import Home from '../../pages/Home/Home';
import About from '../../pages/About/About';
import Contact from '../../pages/Contact/Contact';
import Jobs from '../../pages/Jobs/Jobs';
import Error404 from '../../ErrorPages/Error404/Error404';
import Register from '../../pages/Members/Membership_Register';
import Events from '../../pages/Events/Events';
import EventsDetails from '../../pages/Events/EventDetails';



const Router = () => {
  return (
    <>
      <Header />
      <Navbar />

      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/event_details/:slug" element={<EventsDetails />} />
          <Route path="/membership_register" element={<Register />} />

          {/* Protected Routes */}


          {/* Catch-all 404 */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
};

export default Router;
